import { PostAPIWithoutRequestAndKeyData } from "src/component/api/helper/apiHelper";
export const SelectForDropdown = async () => {
  return PostAPIWithoutRequestAndKeyData("LoanMaster/SelectForDropdown");
};
